import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {CalculatorComponent} from './calculator.component'
import {PensionCalculatorComponent} from './pension-calculator/pension-calculator.component'
import { PensionCalculatorSetupComponent } from './pension-calculator-setup/pension-calculator-setup.component';

const routes = [
  {
    path: 'calculator',
    component: CalculatorComponent,
   canActivate:[CanActivateViaAuthGuard],
    children: [
      {
        path: 'pensioncalculator',
        component: PensionCalculatorComponent,
        canActivate:[CanActivateViaAuthGuard]
      },
      {
        path: 'pensioncalculatorsetup',
        component: PensionCalculatorSetupComponent,
        canActivate:[CanActivateViaAuthGuard]
      }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CalculatorRoutingModule { }
